module.exports = __webpack_public_path__ + "static/img/douyin.096e070.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/douyin.jpg
// module id = Zi8I
// module chunks = 1